import { ISegment, ICaptionWithStyles } from '../types'

type MergedCaption = {
    mergedCaption: string
    mergedCaptionLayers: ICaptionWithStyles[]
}

export const getMergedCaption = (firstSegment: ISegment, lastSegment: ISegment): MergedCaption => {
    let mergedCaption = ''
    let mergedCaptionLayers: Array<ICaptionWithStyles> = []
    if (firstSegment.caption) {
        mergedCaption += firstSegment.caption
    }
    if (lastSegment.caption) {
        if (firstSegment.caption) {
            mergedCaption += ' '
        }
        mergedCaption += lastSegment.caption
    }

    if (firstSegment.editParams?.captions) {
        mergedCaptionLayers.push(...firstSegment.editParams!.captions)
    }
    if (lastSegment.editParams?.captions) {
        mergedCaptionLayers.push(...lastSegment.editParams!.captions)
    }

    return { mergedCaption, mergedCaptionLayers }
}
